import { z } from "zod";

import { AttachmentLike } from "@/data/attachments";
import { UserBase } from "@/data/users";

import { LifecycleActionPerformedCodelist } from "./LifecycleActionPerformed";

export const LifecycleAction = z.object({
  completionDate: z.string(),

  actionPerformed: LifecycleActionPerformedCodelist,

  comment: z.string().nullable(),
  externalComment: z.string().nullish(),
  attachments: z.array(AttachmentLike).nullish(),

  completedBy: UserBase.extend({
    position: z
      .object({
        name: z.string().nullable(),
      })
      .nullish(),
  }).nullish(),
});

export type LifecycleAction = z.infer<typeof LifecycleAction>;
